import React from "react";
import CarouselSmall from "./CarouselSmall";
import BlogCard from "./BlogCard";

const BlogCarousel = ({ data }) => {
  if (!data) {
    return null;
  }

  return (
    <div className="relative">
      <CarouselSmall itemsToShow={3}>
        {data.map((blog) => (
          <BlogCard key={blog?.id} data={blog} />
        ))}
      </CarouselSmall>
    </div>
  );
};

export default BlogCarousel;
